import { routePaths } from "./constants";

import React from "react";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import type { Module } from "src/system/module.types.ts";
import type { B2bGateOrderResource } from "@exonn/js-sdk";
import type { B2bGateOrderRow } from "src/admin/lists/b2b-gate-order/list.types.ts";

export const module: Module<B2bGateOrderResource, B2bGateOrderRow> = {
  id: ResourceEnum.B2bGateOrder,

  bigIcon: <i className="icon-20-selling" />,
  smallIcon: <i className="icon-15-selling" />,
  name: (t: TFunction) => t("moduleName.supplier-orders"),
  edit: {
    routeObject: {
      path: routePaths.edit.root,
      lazy: () => import("./routes/edit/edit.route.tsx"),
    },
  },
  list: {
    hideDeleteAction: (row) => {
      return row.is_child || row.is_blocked;
    },
    hideEditAction: (row: B2bGateOrderRow) => {
      return row.is_child;
    },
  },
  tabs: {
    // I don't know how to create b2b gate order on plus button click
    // To be more specific I don't know what animation to show to a user
    // b2b gate order have many exceptions
    // one exception it must create a new order 'immediately' when user clicks 'new' button
    // unlike in other modules where user first is navigated to the 'new' tab
    // thats why I am simply disabling plus button in this module
    hidePlusButton: true,
    edit: {
      getTitle: (resource: B2bGateOrderResource) => resource.order_number,
    },
  },
};
